<template>
  <v-app-bar
    class="overflow-x-auto overflow-y-hidden"
    color="#fff"
    height="72px"
    outlined
    flat
    fixed
    :style="main_style_padding"
    :class="$style.hide_horizontal_scroll"
  >
    <div :class="$style.barWrap">
      <div :class="$style.sidebarBtnWrap">
        <v-btn
          v-if="is_not_desktop"
          icon
          :class="$style.sidebarBtn"
          @click.stop="toggle_sidebar(!is_mini_sidebar)"
        >
          <v-icon v-show="is_not_desktop ? true : is_mini_sidebar"> mdi-chevron-right </v-icon>
          <v-icon
            v-if="!is_not_desktop"
            v-show="!is_mini_sidebar"
          >
            mdi-chevron-left
          </v-icon>
        </v-btn>
      </div>
      <div :class="$style.btnsWrap">
        <v-btn
          class="ml-2"
          v-if="!searchVisible && $vuetify.breakpoint.xs"
          @click="searchVisible = !searchVisible"
          icon
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
        <div
          style="min-width: 200px;"
          v-if="searchVisible || $vuetify.breakpoint.smAndUp"
          class="d-flex align-center ml-6"
        >
          <v-tooltip
            v-model="searchError"
            bottom
            color="error"
            :open-on-click="false"
            :open-on-focus="false"
            :open-on-hover="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <Search
                v-if="show_global_search"
                v-model="search_text"
                :class="$style.headerSearchForm"
                dense
                :rules="[v => !v || is_length(v, { min: 3 }) || min_length_err(3)]"
                :hide_details="true"
                @clear="clear_search"
                @submit="submit_search"
                @keydown.enter.prevent="submit_search"
                @update:error="onErrorUpdate"
                v-bind="attrs"
                v-on="on"
              />
            </template>
            <span>Не менее трёх символов</span>
          </v-tooltip>

        </div>
        <!-- <HeaderSearch @submit="search" /> -->
        <div :class="$style.header_container">
          <DateTime
            class="ml-4"
            v-if="!is_not_desktop"
            @go_to_calendar="go_to_calendar"
          />
          <div class="d-flex align-center">
            <v-btn
              v-if="polls.length"
              :class="$style.pollsBtn"
              class="flex gap-4 ml-4"
              color="accent darken-4"
              depressed
              @click="toggle_polls_sidebar(!is_polls_sidebar)"
            >
              <v-icon>mdi-message-text-fast-outline</v-icon>
              <span class="ml-2 hidden-xs-only">Пройти опрос</span>
            </v-btn>
            <v-btn
              v-if="is_not_accessible_role()"
              icon
              :class="$style.notifications"
              @click="open_cart"
            >
              <span>
                <v-icon>mdi-cart-outline</v-icon>
                <Badge
                  v-if="prods.length"
                  :color="'accent darken-4'"
                  :content="prods.length"
                  offset-y="-1"
                  offset-x="10"
                />
              </span>
            </v-btn>

            <!-- <v-tooltip
              bottom
              color="primary darken-3"
              :open-delay="500"
            >
              <template
                v-slot:activator="{ on, attrs }"
              >
                <v-btn
                  v-if="is_available_patchnotes_page"
                  v-bind="attrs"
                  v-on="on"
                  icon
                  :class="$style.notifications"
                  @click="go_to_patchnotes"
                >
                  <span>
                    <v-icon>mdi-help-circle-outline</v-icon>
                  </span>
                </v-btn>
              </template>
              <span>
                Что нового?
              </span>
            </v-tooltip> -->

            <v-tooltip
              bottom
              color="primary darken-3"
              :open-delay="500"
            >
              <template
                v-slot:activator="{ on, attrs }"
              >
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  :class="$style.notifications"
                  @click="togle_notification_bar(!is_notification_bar)"
                >
                  <span>
                    <v-icon>mdi-bell-outline</v-icon>
                    <Badge
                      v-if="number_unread_notifications !== 0"
                      :content="number_unread_notifications < 100 ? number_unread_notifications : '99+'"
                      offset-y="-1"
                      offset-x="10"
                    />
                  </span>
                </v-btn>
              </template>
              <span>
                Уведомления
              </span>
            </v-tooltip>

            <!-- Меню с виджетами -->

            <v-tooltip
              bottom
              color="primary darken-3"
              :open-delay="500"
            >
              <template
                v-slot:activator="{ on, attrs }"
              >
                <div
                  v-bind="attrs"
                  v-on="on"
                >
                  <WidgetsMenu />
                </div>
              </template>
              <span>Сервисы АТОЛ</span>
            </v-tooltip>

            <!-- Кнопка профайла + выход -->
            <v-menu
              bottom
              min-width="200px"
              rounded="sm"
              offset-y
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on }">
                <v-btn

                  icon
                  v-on="on"
                >
                  <v-avatar
                    size="32"
                    v-if="avatar"
                  >
                    <img
                      :class="$style.img_avatar"
                      :src="avatar"
                      alt="avatar"
                    >
                  </v-avatar>

                  <v-avatar
                    size="36"
                    v-else
                  >
                    <v-icon>mdi-account-circle-outline</v-icon>
                  </v-avatar>

                </v-btn>
              </template>

              <v-list
                :class="$style.menuBox"
              >
                <ul>
                  <li class="d-flex flex-column">
                    <div
                      class="d-flex align-center"
                      :class="$style.menu_list_item_user"
                      @click="go_to_my_profile"
                    >
                      <div class="mx-3">
                        <v-icon
                          size="28"
                          text
                        >
                          mdi-account-circle-outline
                        </v-icon>
                      </div>
                      <div class="d-flex flex-column">
                        <span
                          :class="$style.menu_list_item_text"
                          class="font-weight-medium mt-2"
                        >{{ me.name }} {{ me.patronymic }}</span>
                        <span
                          :class="$style.menu_list_item_text"
                          class="font-weight-medium mb-2"
                        >{{ me.surname }}</span>
                      </div>
                    </div>
                  </li>
                  <v-divider class="my-2" />
                  <li
                    class="d-flex"
                    :class="$style.menu_list_exitBtn"
                    @click="go_to_my_company"
                  >
                    <div class="mx-3">
                      <v-icon
                        size="28"
                        text
                      >
                        mdi-domain
                      </v-icon>
                    </div>
                    <div>
                      <span
                        :class="$style.menu_list_item_text"
                        class="my-2"
                      >{{ me.company }}</span>
                    </div>
                  </li>
                  <v-divider class="my-2" />
                  <li
                    :class="[$style.menu_list_codes]"
                    style="display: flex; align-items: start;"
                  >
                    <div>
                      <v-icon
                        class="mr-0 pl-3"
                        size="28"
                        text
                      >
                        mdi-qrcode
                      </v-icon>
                    </div>
                    <div>
                      <div
                        class="d-flex align-center mx-3"
                        :class="[$style.menu_list_item_code]"
                      >
                        <span class="text-no-wrap mr-3">Код партнера:</span>
                        <span :class="[$style.textCode]">{{ me.partner_code || ''  }}</span>
                      </div>
                      <div
                        v-if="me.sigma_partner_code"
                        class="d-flex align-center mx-3"
                        :class="[$style.menu_list_item_code]"
                      >
                        <span class="text-no-wrap mr-3">Код партнера Sigma:</span>
                        <span :class="[$style.textCode]">{{ me.sigma_partner_code || '' }}</span>
                      </div>
                      <div
                        v-if="me.frontol_partner_code"
                        class="d-flex align-center mx-3"
                        :class="[$style.menu_list_item_code]"
                      >
                        <span class="text-no-wrap mr-3">Код партнера Frontol:</span>
                        <span :class="[$style.textCode]">{{ me.frontol_partner_code || '' }}</span>
                      </div>
                    </div>
                  </li>
                  <v-divider class="my-2" />
                  <li
                    :class="$style.menu_list_exitBtn"
                    @click="logout"
                    class="d-flex align-center"
                  >
                    <div class="mx-3">
                      <v-icon
                        color="error"
                        size="28"
                        text
                      >
                        mdi-logout
                      </v-icon>
                    </div>
                    <div>
                      <span :class="$style.menu_list_item_text">Выход</span>
                    </div>
                  </li>
                </ul>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>
    </div>
  </v-app-bar>
</template>

<script lang="ts">
import { Component, Vue, Mixins } from 'vue-property-decorator';
// BEFORE KEYCLOAK
// auth_store,
import {
  global_store, user_store, notifications_store, cart_store, polls_store, global_search_store,
} from '@/store';
import { UserRoles, UserRolesTranslate } from '@/enums';
import LogoWhite from '@/assets/icons/logo-white.svg?inline';
import { UserShared } from '@/modules/user/shared/types';
// import { Auth } from '@/modules/auth/types';
import { MainPage } from '@/modules/main-page/types';
import WidgetsMenu from '@/components/widgets-menu/WidgetsMenu.vue';
import { SimpleEnumType } from '@/types';
import { Avatar } from '@/components/avatar';
import { DateTime } from '@/components/date-time';
import { Organizations } from '@/modules/organizations/types';
import { Patchnotes } from '@/modules/patchnotes/types';
import { GlobalSearch, SearchFilters } from '@/modules/global-search/types';
import ValidateMixin from '@/mixins/validate';
import { EventsCalendar } from '@/modules/events-calendar/types';
import { Badge } from '../global/badge';
import { Search } from '../search';

@Component({
  components: {
    DateTime,
    LogoWhite,
    Badge,
    WidgetsMenu,
    Avatar,
    Search,
  },
})
export default class HeaderApp extends Mixins(ValidateMixin) {
  search_text = '';

  searchVisible = false;
  searchError = false;

  get polls() {
    return polls_store.state.polls;
  }

  get is_not_desktop() {
    return global_store.state.isTablet || global_store.state.isMobile;
  }

  get number_unread_notifications() {
    return notifications_store.state.number_unread_notifications;
  }

  get go_to_main() {
    return { name: MainPage.Pages.MAIN };
  }

  get me() {
    return user_store.state.me;
  }

  get initials() {
    const s = this.me.surname?.length ? this.me.surname : '';
    const n = this.me?.name?.length ? `${this.me.name[0]}.` : '';
    const p = this.me?.patronymic?.length ? `${this.me.patronymic[0]}.` : '';

    return `${s} ${n} ${p}`.trim();
  }

  get is_mini_sidebar() {
    return global_store.state.is_mini_sidebar;
  }

  get is_notification_bar() {
    return global_store.state.is_notification_bar;
  }

  get available_pages() {
    return user_store.state.me.available_pages || [];
  }

  get is_available_patchnotes_page() {
    return this.available_pages.find((el) => el.slug === Patchnotes.Pages.PATCH_NOTES)?.is_active;
  }

  get prods() {
    return cart_store.state.carts_products;
  }

  get is_polls_sidebar() {
    return global_store.state.is_polls_sidebar;
  }

  get main_style_padding() {
    if (this.is_not_desktop) {
      return {
        paddingLeft: '0px',
      };
    }
    return {
      paddingLeft: this.is_mini_sidebar ? '75px' : '300px',
    };
  }

  go_to_my_profile() {
    this.$router.push({
      name: UserShared.Pages.PROFILE,
    });
  }

  go_to_my_company() {
    this.$router.push({
      name: Organizations.Pages.ORGANIZATIONS,
    });
  }

  go_to_patchnotes() {
    if (this.$route.path !== `/${Patchnotes.Pages.PATCHNOTES}`) {
      this.$router.push({
        name: Patchnotes.Pages.PATCHNOTES,
      });
    }
  }

  toggle_sidebar(value: boolean) {
    global_store.mutations.SIDEBAR_TOGGLE(value);
  }

  togle_notification_bar(value: boolean) {
    global_store.mutations.NOTIFICATIONS_BAR_TOGGLE(value);
  }

  toggle_polls_sidebar(value: boolean) {
    global_store.mutations.POLLS_SIDEBAR_TOGGLE(value);
  }

  get is_admin() {
    return this.me?.roles?.length === 1 && this.me.roles[0].slug === UserRoles.External.ADMIN;
  }

  get user_name() {
    return this.is_admin ? this.me.roles[0].name : this.initials;
  }

  is_not_accessible_role() {
    const excluded_roles = [
      UserRoles.Internal.ENGINEER,
      UserRoles.Internal.SALE_MANAGER,
      UserRoles.Internal.SALE_MANAGER_FULL_PRICE,
      UserRoles.Internal.MARKETER,
      UserRoles.Internal.SERVICE_MANAGER_NEW_REGIONS,
    ];

    const has_accessible_role = this.me.roles.some((role) => {
      const role_slug = role.slug as UserRoles.Internal;

      return !excluded_roles.includes(role_slug);
    });

    return has_accessible_role;
  }

  format_roles(arr: SimpleEnumType<UserRoles.Internal | UserRoles.External>[]) {
    const formated = arr.map((e) => UserRolesTranslate[e.slug]);

    return formated.length >= 2 ? formated.join(', ') : formated.join();
  }

  get avatar() {
    return this.me?.image || '';
  }

  get original_initials() {
    const { name = '', surname = '' } = user_store.state.me;

    return `${name || ''} ${surname || ''}`;
  }

  get show_global_search() {
    const item = this.available_pages.find((page) => page.slug === GlobalSearch.Pages.GLOBAL_SEARCH_SLUG);

    if (item?.is_active && item?.is_global_active) {
      return true;
    }

    if (this.$route.name === GlobalSearch.Pages.SEARCH && !item?.is_active && item?.is_global_active) {
      return true;
    }

    return false;
  }

  // BEFORE KEYCLOAK
  // async logout() {
  //   try {
  //     await auth_store.actions.logout();
  //     user_store.actions.reset_user();
  //     this.$router.push({ name: Auth.Pages.SIGN_IN });
  //   } catch (error) {
  //     console.log(error);
  //     this.$router.push({ name: Auth.Pages.SIGN_IN });
  //   }
  // }
  async logout() {
    try {
      user_store.actions.reset_user();
      Vue.keycloak_instance.logout();
    } catch (error) {
      console.log(error);
    }
  }

  open_cart() {
    cart_store.mutations.TOGGLE_IS_OPEN_CART(true);
  }

  submit_search() {
    if (this.search_text.trim().length < 3) {
      return;
    }

    this.filter_update('search', this.search_text);

    if (this.$route.name !== GlobalSearch.Pages.SEARCH) {
      this.$router.push({
        name: GlobalSearch.Pages.SEARCH,
      });
      this.get_search();
    } else {
      this.get_search();
    }
  }

  get search() {
    return global_search_store.state.search;
  }

  clear_search() {
    this.searchVisible = false;

    this.filter_update('search', '');

    global_search_store.mutations.CLEAR_SEARCH();
  }

  filter_update(key: keyof SearchFilters, value: unknown) {
    global_search_store.mutations.UPD_FILTER_KEY({ key, value });
  }

  get_search() {
    global_search_store.mutations.UPD_SELECTED_ITEM('all');
    global_search_store.mutations.UPD_FILTER_KEY({ key: 'page', value: '' });
    global_search_store.actions.get_search();
  }

  go_to_calendar() {
    if (this.$route.path !== `/${EventsCalendar.Pages.CALENDAR}`) {
      this.$router.push({
        name: EventsCalendar.Pages.CALENDAR,
      });
    }
  }

  onErrorUpdate(value: boolean) {
    this.searchError = value;
  }
}
</script>

<style module lang="scss">
.appBar {
  z-index: 7 !important;
  border-bottom: 1px solid $primary_lighten4 !important;
}

.barWrap {
  display: flex;
  align-items: center;
  width: 100%;
}

.notifications {
  margin-left: auto;
}

.notificationsContentBtn {
  display: flex;
  align-items: center;
}

.apps {
  margin-right: 14px;
}

.exitBtn {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.exitBtn:hover {
  background-color: #e7e7e7;
}
.btnsWrap {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.header_container {
  display: flex;
  align-items: center;
  gap: 12px;
}

// стили меню пользователя
.menuBox {
  font-size: 16px;
}

.menuBox li {
  list-style-type: none;
}

.menuBox ul {
  padding: 0;
}
.menu_list_exitBtn {
  padding: 12px 0;
}
.menu_list_item_user:hover {
  background-color: #eae8e8;
  cursor: pointer;
}
.menu_list_codes {
  padding: 12px 0;
}
.menu_list_item_code {
  display: flex;
  justify-content: space-between;
}
.menu_list_exitBtn:hover {
  background-color: #eae8e8;
  cursor: pointer;
}
.img_avatar {
  width: 48px !important;
  height: 48px !important;
}

.headerSearchForm {
  width: 400px;
}

.pollsBtn {
  border-radius: 18px !important;
}

.noHover:hover {
  background-color: inherit !important;
  color: inherit !important;
  text-decoration: none !important;
}

.textCode {
  font-weight: 500;
}

@media (min-width: 600px) and (max-width: 959px) {
  .headerSearchForm {
    width: 100%;
  }
}

@media (max-width: 599px) {
  .headerSearchForm {
    width: 100%;
  }
}

.hide_horizontal_scroll::-webkit-scrollbar {
  height: 0 !important;  /* ключевое для горизонтального скролла */
  display: none;
}

.hide_horizontal_scroll {
  -ms-overflow-style: none;  /* IE и Edge */
  scrollbar-width: none;     /* Firefox */
}

</style>
